import Button from "@mittwald/flow-components/dist/components/Button";
import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
export const ToolSettingsButton = styled(Button) `
  flex-shrink: 0;
  &.info {
    background-color: ${color.brand.primary.default};
  }
  &.info:hover {
    background-color: ${color.brand.primary.dark};
  }

  &.info.active,
  &.info:active {
    background-color: ${color.brand.primary.darker};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9vbFNldHRpbmdzQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFja3NpZGVSZW5kZXJlci9jb21wb25lbnRzL01haW5Db250ZW50UGFnZVRpdGxlL3N0eWxlZC9Ub29sU2V0dGluZ3NCdXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sa0RBQWtELENBQUM7QUFDdEUsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3ZFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBRXZDLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTs7O3dCQUd4QixLQUFLLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPOzs7d0JBRzNCLEtBQUssQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUk7Ozs7O3dCQUt4QixLQUFLLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNOztDQUVqRCxDQUFDIn0=